@if (isOpen) {
  <div class="gallery-overlay">
    <button class="close-btn" (click)="close()">×</button>
    <div class="main-image-container">
      <button class="nav-btn prev-btn" (click)="previous()">&#10094;</button>
      <img
        [src]="imageUrls[currentIndex]"
        alt="Current image"
        class="main-image"
      />
      <button class="nav-btn next-btn" (click)="next()">&#10095;</button>
    </div>
    <div class="thumbnails-container">
      @for (url of imageUrls; track url; let i = $index) {
        <div
          class="thumbnail"
          [class.active]="i === currentIndex"
          (click)="setCurrentImage(i)"
        >
          <img [src]="url" alt="Thumbnail" />
        </div>
      }
    </div>
  </div>
}
